import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { currency, num } from "@/lib/format";
import { PageHeader } from "@/components/Layout";
import { Warehouse, MapPin, User, ArrowRight } from "lucide-react";

export default function Facilities() {
  const [facilities, setFacilities] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { api.get("/facilities").then((r) => setFacilities(r.data)); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto space-y-6">
      <PageHeader title="Facilities" subtitle="Multi-location inventory network" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {facilities.map((f) => (
          <div key={f.id} data-testid={`facility-card-${f.id}`} onClick={() => navigate(`/facilities/${f.id}`)}
            className="group rounded-xl bg-white border border-stone-200/80 shadow-sm hover:shadow-md hover:border-stone-300 transition-all cursor-pointer overflow-hidden animate-fade-up">
            <div className="h-1.5" style={{ background: f.accent }} />
            <div className="p-5">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="h-11 w-11 rounded-lg flex items-center justify-center" style={{ background: `${f.accent}18`, color: f.accent }}>
                    <Warehouse className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-stone-900 leading-tight">{f.name}</h3>
                    <p className="text-xs text-stone-500 flex items-center gap-1"><MapPin className="h-3 w-3" />{f.type}</p>
                  </div>
                </div>
                <ArrowRight className="h-5 w-5 text-stone-300 group-hover:text-stone-600 group-hover:translate-x-0.5 transition-all" />
              </div>
              <p className="text-sm text-stone-500 mt-3 leading-relaxed">{f.description}</p>
              <div className="flex items-center justify-between mt-4 pt-4 border-t border-stone-100">
                <div>
                  <div className="text-xs uppercase tracking-wide text-stone-400">Asset Value</div>
                  <div className="text-xl font-extrabold font-mono text-stone-900">{currency(f.total_value)}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs uppercase tracking-wide text-stone-400">SKUs Held</div>
                  <div className="text-xl font-extrabold font-mono text-stone-900">{num(f.item_count)}</div>
                </div>
                <div className="text-right flex items-center gap-1.5 text-xs text-stone-500">
                  <User className="h-3.5 w-3.5" />{f.manager}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
